import React from 'react';

// Components
import Item from './Item';

// Styles
import styles from './index.module.sass';

//Objects
import taxonomy from '../Queries/menuObject';

const Menu = (props) => {
  const { open, history = {}, screenSize } = props;

  const cont = process.env.REACT_APP_COUNTRY;

  return (
    <>
      <div id={styles.departaments} className={`${styles[screenSize]} ${styles[open]}`}>
        {taxonomy.map((val, key) => {
          if (val.mobile === 'true') return null;
          else if (val.country && val.country === cont)
            return <Item key={key} index={key} history={history} val={val} taxonomy={taxonomy} />;
          else if (val.country && val.country !== cont) return null;
          else
            return <Item key={key} index={key} history={history} val={val} taxonomy={taxonomy} />;
        })}
      </div>
    </>
  );
};

export default Menu;
